<template>
  <!-- 商品价格区域 -->
  <div class="good-price-area" :style="(customStyle && customStyle.root) || {}">
    <!-- 商品总价占位符【用于保证商品模块高度和内部元素位置】 -->
    <div
      v-if="totalPricePlaceholder"
      class="good-total-price-placeholder"
    ></div>
    <!-- 【商品单价 [会员价 | 划线价] 加购按钮】 -->
    <div
      :class="[
        'good-price',
        customOperator.type === 'large' ? 'large' : '',
        showDisCountTag ? 'show-dis-count-tag' : ''
      ]"
    >
      <!-- 未登录价格保护 -->
      <div v-if="ssuInfo.ssuPrice.priceShield" class="price-shield">
        {{ ssuInfo.ssuPrice.priceShieldText }}
      </div>
      <!-- 价格部分 -->
      <div v-else class="price">
        <p v-if="showSsuFpText" class="ssu-fp-text">
          {{ ssuInfo.ssuFpText }}
        </p>
        <!-- 商品单价 -->
        <p :class="['unit-price', !showOriginalPrice ? 'fill' : '']">
          <span class="prefix-price">{{ unitPrice.prefix }}</span>
          <span
            class="value"
            :style="(customStyle && customStyle.totalPrice) || {}"
            >{{ unitPrice.price }}</span
          >
          <span v-if="ssuInfo.ssuPrice.unitPrice" class="unit">{{
            unitPrice.unit
          }}</span>
          <!-- 划线价 -->
        </p>

        <p
          v-if="showOriginalPrice"
          :class="[
            'original-price',
            showDisCountTag ? 'show-dis-count-tag' : ''
          ]"
        >
          {{ '￥' + ssuInfo.ssuPrice.crossedPrice }}
        </p>
      </div>
      <!-- 加购按钮部分 -->
      <div v-if="customOperator.type === 'normal'" class="operator-wrapper">
        <new-operator
          :use-simple="customOperator.simple"
          :use-arrived-notice-icon="customOperator.useArrivedNoticeIcon"
          show-simple-count
          :show-promote-tip="customOperator.showPromoteTip"
          :ssu="ssu"
          :is-hint="ssu.promise.isHintNoArriveAm"
          :show-add-img="showDisCountTag"
          :show-shadow="showDisCountTag ? false : true"
          @add="addGoods"
          @subtract="subtractGoods"
          @goDetail="goDetail"
        />
      </div>
    </div>

    <div
      v-if="showDiscount"
      :class="[
        discountPrice
          ? 'discount-price-wrapper'
          : noDiscountStage
          ? ''
          : 'discount-wrapper'
      ]"
    >
      <!-- 2、3 * n 的划线价 -->
      <div v-if="showMultOriginalPrice" class="mult-original-price">
        {{ '￥' + ssuInfo.ssuPrice.crossedPrice }}
      </div>

      <!-- 优惠后单价 -->
      <div v-if="showPredictPrice" class="discount-price">
        <tag
          :corner-radius="6"
          :primary-color="'#fff'"
          :tag-style="predictPriceStyle"
          :font-size="11"
        >
          {{ predictPrice }}
        </tag>
      </div>
    </div>

    <!-- 加购按钮部分 -->
    <div v-if="customOperator.type === 'large'" class="operator-wrapper-large">
      <new-operator
        :use-simple="customOperator.simple"
        :use-icon="false"
        :btn-text="'加入购物车'"
        :btn-width="customOperator.btnWith || 1.92"
        :btn-type="customOperator.canScroll ? 'normal' : 'large'"
        :use-arrived-notice-icon="customOperator.simple"
        show-simple-count
        :show-promote-tip="customOperator.showPromoteTip"
        :ssu="ssu"
        :show-can-not-buy="false"
        @add="addGoods"
        @subtract="subtractGoods"
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import NewOperator from '@/common/widgets/newOperator/newIndex.vue'
import Tag from '@/common/widgets/good_tag'
export default {
  components: {
    NewOperator,
    Tag
  },
  props: {
    ssu: {
      type: Object,
      default: () => {}
    },
    commonTracerPamas: {
      type: Object,
      default: () => {}
    },
    ssuInfo: {
      type: Object,
      default: () => {}
    },
    showGoodPrice: {
      type: Boolean,
      default: true
    },
    showSsuFpText: {
      type: Boolean,
      default: false
    },
    showMultOriginalPrice: {
      type: Boolean,
      default: false
    },
    showDiscountPrice: {
      type: Boolean,
      default: false
    },
    noDiscountStage: {
      type: Boolean,
      default: false
    },
    totalPricePlaceholder: {
      type: Boolean,
      default: false
    },
    showTotalPriceWithFp: {
      type: Boolean,
      default: false
    },
    customOperator: {
      type: Object,
      default: () => {
        return {
          simple: true,
          showPromoteTip: false,
          type: 'normal',
          canScroll: false
        }
      }
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    formatInfo: {
      type: String,
      default: ''
    },
    showDiscount: {
      type: Boolean,
      default: true
    },
    showDisCountTag: {
      type: Boolean,
      default: false
    },
    isPerformanceType: {
      type: Boolean,
      default: false
    },
    showOriginalPrice: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    predictPriceStyle() {
      return {
        'background-image': 'linear-gradient(90deg, #ff7d5e, #ff3410)',
        'border-top-left-radius': 0,
        'padding-left': '12px',
        'padding-right': '12px'
      }
    },
    // 单价展示处理
    unitPrice() {
      const approximateShow = this.ssuInfo.ssuPrice?.isShowWeightUnitPrice === 1
      const normalPrefix = approximateShow ? '约￥' : '￥'
      const normalPrice = this.ssuInfo.ssuPrice[
        approximateShow ? 'weightUnitPrice' : 'unitPrice'
      ]
      const normalUnit = this.ssuInfo.ssuPrice[
        approximateShow ? 'weightPriceUnit' : 'priceUnit'
      ]

      return {
        prefix: normalPrefix,
        price: normalPrice,
        unit: '/' + normalUnit
      }
    },

    // 绿卡原价
    originPriceDesc() {
      return this.ssuInfo?.ssuPrice?.originPriceDesc
    },

    // 优惠后价格
    predictPrice() {
      if (this.isPerformanceType) {
        if (this.ssuInfo.ssuPrice?.predictTotalPrice) {
          return `
            ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.predictTypeMsgPrefix}
            ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.priceSymbol}
            ${this.ssuInfo.ssuPrice?.predictTotalPrice}
          `
        } else {
          return `
            总价￥
            ${this.ssuInfo.ssuPrice?.totalPrice}
          `
        }
      }
      if (
        !!this.ssuInfo.ssuPrice?.isPredictPrice &&
        this.ssuInfo.ssuPrice?.predictSsuUnitPriceText
      ) {
        return `
        ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.predictTypeMsgPrefix}
        ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.priceSymbol}
        ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.predictShowPrice}
        ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.predictPriceUnitSuffix}
      `
      } else {
        return ''
      }
    },
    showPredictPrice() {
      return this.showDiscountPrice && this.predictPrice
    },
    discountPrice() {
      return this.showPredictPrice
    }
  },
  methods: {
    // 统一商品模块埋点上报方法
    tracerReport(type) {
      const tickerInfo = this.ssuInfo.tickerInfo
      if (tickerInfo) {
        this.$track(
          tickerInfo[type].spm,
          Object.assign(
            {},
            tickerInfo.data,
            tickerInfo[type].spmJson,
            this.commonTracerPamas,
            this.ssu.extraTrack ? this.ssu.extraTrack : {}
          )
        )
      } else {
        this.$emit(type)
      }
    },
    // 商品加购处理
    addGoods() {
      // 加购埋点
      this.tracerReport('addcart')
    },
    // 商品减购处理
    subtractGoods() {
      // 减购埋点
      this.tracerReport('subcart')
    },
    goDetail() {
      this.$emit('goDetail')
    }
  }
}
</script>

<style lang="scss" scoped>
.good-price-area {
  margin-top: 0.24rem;
}

.operator-wrapper-large {
  margin-top: 0.08rem;
}

.good-total-price {
  height: 0.34rem;
  margin-bottom: -0.1rem;

  font-size: 0.24rem;
  line-height: 0.34rem;
  color: #8c8c8c;
  @include text-overflow-ellipsis-single;

  &-placeholder {
    height: 0.34rem;
    margin-bottom: -0.1rem;

    line-height: 0.34rem;
  }
}
.good-format-info {
  height: 0.34rem;
  margin-bottom: -0.1rem;

  font-size: 0.24rem;
  line-height: 0.34rem;
  color: #8c8c8c;
  @include text-overflow-ellipsis-single;
}

.good-price {
  @include flex(row, space-between, center, nowrap);
  &.large {
    margin-top: 0.1rem;
  }
  &.show-dis-count-tag {
    background-color: #fff3ef;

    border-radius: 0 8px 8px 8px;
  }
  .price-shield {
    font-size: 0.24rem;
    line-height: 0.32rem;
    color: #f03100;
  }

  .price {
    overflow: hidden;

    flex: auto;

    @include flex(row, flex-start, baseline, nowrap);

    ::v-deep .member-price {
      margin-left: 0.12rem;

      flex: none;
    }

    .unit-price {
      flex: none;

      font-size: 0.4rem;
      white-space: nowrap;
      &.fill {
        flex: auto;

        color: #8c8c8c;
        @include text-overflow-ellipsis-single;
      }

      .prefix-price {
        font-size: 0.2rem;
        font-weight: 700;
        color: #f03100;
      }

      .value {
        font-weight: 700;
        color: #f03100;
      }

      .unit {
        margin-left: 0.04rem;

        font-size: 0.26rem;
        font-weight: 700;

        color: #f03100;
      }
    }

    .original-price {
      margin-left: 0.12rem;

      font-size: 0.24rem;
      text-decoration: line-through;
      white-space: nowrap;

      color: $c-text-lighter;
      &.show-dis-count-tag {
        color: #f9a48e;
      }
    }
    .ssu-fp-text {
      margin-right: 0.08rem;

      padding: 0.02rem 0.08rem;

      background-color: #f5f5f5;

      border-radius: 0.08rem;

      text-align: center;

      white-space: nowrap;

      vertical-align: middle;

      @include text(0.2rem, #262626);
    }
  }

  .operator-wrapper {
    flex: none;
  }
}

.discount-wrapper {
  height: 18px;
  margin-top: 2px;

  line-height: 18px;
}
.discount-price-wrapper {
  height: 18px;
  margin-top: 2px;
}
.discount-price {
  overflow: hidden;
  box-sizing: content-box;

  @include flex(row, flex-start, flex-start, wrap);
}
.mult-original-price {
  text-decoration: line-through;
  @include text-overflow-ellipsis-single;
  @include text(0.24rem, #999);
}
</style>
